import React from "react";
import { useSavedManagers } from "../../hooks/useSavedManagers";
import SavedManagerRow from "./SavedManagerRow";
import LoadingSpinner from "./LoadingSpinner";
import "./SavedManagersSection.css";

const SavedManagersSection = () => {
  const { savedManagers, isLoading, error, hasMore, loadMore, refresh } =
    useSavedManagers();

  if (error) {
    return (
      <div className="saved-managers-section">
        <div className="error-container">
          <p className="error-message">{error}</p>
          <button onClick={refresh} className="retry-btn">
            Try Again
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="saved-managers-section">
      <div className="section-header">
        <h3>Your Saved Managers</h3>
        {savedManagers.length > 0 && (
          <button onClick={refresh} className="refresh-btn">
            <i className="bi bi-arrow-clockwise"></i>
            Refresh
          </button>
        )}
      </div>

      {isLoading && savedManagers.length === 0 ? (
        <div className="loading-container">
          <LoadingSpinner size="medium" text="Loading your saved managers..." />
        </div>
      ) : savedManagers.length === 0 ? (
        <div className="empty-state">
          <div className="empty-icon">
            <i className="bi bi-bookmark"></i>
          </div>
          <h4>No saved managers yet</h4>
          <p>
            You haven't saved any manager profiles yet. Start exploring and save
            managers you're interested in!
          </p>
        </div>
      ) : (
        <>
          <div id="parent-id">
            <div className="table-container">
              <table className="table-sms">
                <thead>
                  <tr>
                    <th scope="col" className="text-center">
                      Company
                    </th>
                    <th scope="col" className="text-center">
                      Name
                    </th>
                    <th scope="col" className="text-center">
                      Position
                    </th>
                    <th scope="col" className="text-center">
                      LinkedIn
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {savedManagers.map((manager) => (
                    <SavedManagerRow
                      key={manager.manager_id}
                      manager={manager}
                    />
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {hasMore && (
            <div className="load-more-container">
              <button
                onClick={loadMore}
                className="load-more-btn"
                disabled={isLoading}
              >
                {isLoading ? (
                  <>
                    <span className="loading-spinner-inline"></span>
                    Loading...
                  </>
                ) : (
                  "View More"
                )}
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default SavedManagersSection;
